import React from "react";
import { setHeadlessThemeIsEnabled } from "owa-acui";
import { getIsDarkTheme } from "owa-fabric-theme";
import { useV9BrandTheme } from "owa-react-dom";
import { setAppThemes } from "./setAppThemes";
import { updateAppThemeMode } from "./updateAppThemeMode";

/**
 * Hook to set and update the AppTheme used by 1JS components (including Ribbon)
 */
export const useAppTheme = (): void => {
    const isDarkTheme = getIsDarkTheme();
    const themeV9 = useV9BrandTheme();
    
    setHeadlessThemeIsEnabled(true);
    setAppThemes(themeV9);
    
    React.useEffect(() => {
        updateAppThemeMode(isDarkTheme);
    }, [isDarkTheme]);
};
